import React, { useState } from "react";
import { Modal, Input, Radio } from "antd";

const SwapRefModal = ({ visible, onCancel, onSwap }) => {
  const [targetId, setTargetId] = useState("");
  const [mode, setMode] = useState("swap"); // "swap" or "move"

  const handleOk = () => {
    if (targetId.trim()) {
      onSwap(targetId.trim(), mode); // pass mode
      setTargetId("");
      setMode("swap");
    }
  };

  return (
    <Modal
      title="Reference Action"
      open={visible}
      onOk={handleOk}
      onCancel={() => {
        setTargetId("");
        setMode("swap");
        onCancel();
      }}
      okText={mode === "swap" ? "Swap" : "Move"}
      zIndex={10}
    >
      <div className="flex gap-2 mb-3 mt-5 items-center">
        <label className="w-[80px]">Target ID:</label>
        <Input
          placeholder="e.g. 3"
          value={targetId}
          onChange={(e) => setTargetId(e.target.value)}
        />
      </div>

      <Radio.Group
        onChange={(e) => setMode(e.target.value)}
        value={mode}
        style={{ display: "flex", gap: "1rem" }}
      >
        <Radio value="swap">Swap</Radio>
        <Radio value="move">Move</Radio>
      </Radio.Group>
    </Modal>
  );
};

export default SwapRefModal;

